<!-- splash screen -->
<div #splashScreen class="kt-splash-screen">
	@if (loaderType === 'spinner-logo') {
	<img [ngSrc]="loaderLogo" alt="Logo" height="24" width="91" priority />
	}
	<mat-spinner diameter="40"></mat-spinner>
</div>
